// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_zJZkR","footerWrapper":"index_footerWrapper_FTHpC"};